import { render } from "./ArtistGeneral.vue?vue&type=template&id=c38fac56"
import script from "./ArtistGeneral.vue?vue&type=script&lang=js"
export * from "./ArtistGeneral.vue?vue&type=script&lang=js"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__